import apiClient from './taskboardApiClient';


export default {

    _currentUser: null,

    fetchingUser: false,

    fetchCurrentUser() {
        this.fetchingUser = true;
        return apiClient.currentUser().then(response => {
            this.fetchingUser = false;
            this._currentUser = response.result.user;
            if (this._currentUser) {
                this._currentUser.id = this._currentUser._id;
            }
            return this._currentUser;
        }).catch(error => {
            this.fetchingUser = false;
            return Promise.reject(error);
        });
    },

    isLoggedIn() {
        return this._currentUser !== null;
    },

    getCurrentUser() {
        return this._currentUser;
    },

    login(email, password) {
        return apiClient.login(email, password).then(result => {
            return this.fetchCurrentUser();
        });
    },

    register(email, password) {
        return apiClient.register(email, password).then(result => {
            return this.fetchCurrentUser();
        });
    },

    forgotPassword(email) {
        return apiClient.forgotPassword(email);
    },

    resetPassword(password, resetPasswordToken) {
        return apiClient.resetPassword(password, resetPasswordToken).then(result => {
            return this.fetchCurrentUser();
        });
    },

    logout() {
        return apiClient.logout().then(() => {
            this._currentUser = null;
        });
    }

};



// WEBPACK FOOTER //
// ./src/services/userContext.js